export default __webpack_public_path__ + "static/media/delivery_icon.bac448d9.svg";